import { useContext } from "react";
import css from "../Food.module.css";
import Intro from "../../../components/intro/Intro";
import NotificationsContext from "../../../context/notifications";
import Steps from "../Steps";
import Clickard from "../../../components/Clickard/Clickard";

const Popcorn = () => {
  const { addNotification } = useContext(NotificationsContext);

  return (
    <>
      <Intro
        primary="POPCORN"
        secondary="You'll need 15 minutes, 3 ingredients, and 5 tools. It's fast, easy, and delicious."
        tertiary="Enjoy!"
      />
      <div className="column p01 g1">
        <h2>1. PREPARE</h2>
        <div className="columns_2">
          <div className={css.instruction}>
            <strong className="ctext">INGREDIENTS</strong>
            <div className="flex between">
              <span className="white">olive oil</span>2 tablespoons
            </div>
            <div className="flex between">
              <span className="white">popcorn kernels</span>½ cup
            </div>
            <div className="flex between">
              <span className="white">salt</span>to taste
            </div>
          </div>

          <div className={css.instruction}>
            <strong className="ctext">TOOLS</strong>
            <div className="flex between">
              <span className="underline">½ cup</span>1
            </div>
            <div className="flex between">
              <span className="underline">1 tablespoon</span>1
            </div>
            <div className="flex between">
              <span className="underline">bowl (large)</span>1
            </div>
            <div className="flex between">
              <span className="underline">pot with lid (large)</span>1
            </div>
            <div className="flex between">
              <span className="underline">stove</span>1
            </div>
          </div>
        </div>

        <h2>2. COOK</h2>
        <Steps>
          <p>
            Add to the <span className="underline">pot</span>...
          </p>
          <ul className={css.bullets}>
            <li className="flex between">
              <span className="white">olive oil</span>2 tablespoons
            </li>
            <li className="flex between">
              <span className="white">popcorn kernels</span>3
            </li>
          </ul>
          <p>
            ...then put the <span className="underline">pot</span> on the{" "}
            <span className="underline">stove</span> and set the heat to medium.
          </p>
        </Steps>
        <p className="ctext">
          Wait for the 3 <span className="white">popcorn kernels</span> to pop.
        </p>
        <Steps>
          <p>
            Add the remaining <span className="white">popcorn kernels</span> (½
            cup) to the <span className="underline">pot</span>...
          </p>
          <p>
            ...then put the <span className="underline">lid</span> on.
          </p>
        </Steps>
        <p className="ctext">
          While the <span className="white">popcorn</span> is popping...
        </p>
        <Steps>
          <p>
            Lift the <span className="underline">pot</span>, shake it
            side-to-side a few times, then put it back on the{" "}
            <span className="underline">stove</span>.
          </p>
          <p>(Do this as often as you want, but at least once.)</p>
        </Steps>
        <p className="ctext">
          When the popping slows to once every 3–4 seconds...
        </p>
        <Steps>
          <p>
            Pour the <span className="white">popcorn</span> into the{" "}
            <span className="underline">bowl</span>...
          </p>
          <p>
            ...then sprinkle it with <span className="white">salt</span>,
            tossing (and tasting) it often.
          </p>
        </Steps>
        <button
          className="button"
          onClick={() =>
            addNotification({
              primary: "NICE WORK!",
              secondary: "You did it! Enjoy!",
              type: "success",
              showTime: 4,
            })
          }
        >
          CELEBRATE!
        </button>
        <h2>MORE TO COOK</h2>
        <div className="columns_3">
          <Clickard
            img={{
              src: "https://storage.googleapis.com/squidslippers-media/food/banana_bread/loaf_2x1.jpg",
              alt: "banana bread",
            }}
            link="/cookbook/banana-bread"
            text="Banana Bread"
          />
          <Clickard
            img={{
              src: "https://storage.googleapis.com/squidslippers-media/food/pancakes.webp",
              alt: "pancakes",
            }}
            link="/cookbook/pancakes"
            text="Pancakes"
          />
        </div>
      </div>
    </>
  );
};

export default Popcorn;
